import { TSearchShelfCard } from 'types';

export function hasShelfCardDetail(card: TSearchShelfCard): boolean {
  return (
    !!card.bannerImageUrl?.trim() ||
    !!card.categoryLabel?.trim() ||
    !!card.statusBadge?.trim() ||
    !!card.description?.trim() ||
    card.salaryRows.length > 0
  );
}
